<!-- footer for expired -->
   <div>
    <div class="bg-light more-resources">
    <h2 class="card-title text-center">More options</h2>
    <ul class="tracker-list">
        <li>
          <a class="task"  [routerLink]="['']" (click)="onLogout()">
          <span class="tracker-info">
              <span class="tracker-title">Sign out</span>
          </span>
          <span class="icon-wrap float-end icon-more" style="color: #E25050;"
              ><fa-icon [icon]="['fal', 'sign-out']"></fa-icon>
          </span>
          </a>
        </li>
    </ul>
  </div>

      <div class="signin-details">
        <div class="signin-details-flex">
          <div class="signin-left">
            © 2025 University Hospitals of Leicester
          </div>
          <div class="signin-right">
            <a [routerLink]="['/getting-started', 'terms']">Terms &amp; Conditions</a>&nbsp;|&nbsp;
            <a [routerLink]="['/getting-started', 'privacy']">Privacy Policy</a>
          </div>
        </div>
      </div>
      <div class="">
        <div class="col footer-logos">
          <div class="programme-logo-strap">Incorporating the programmes</div>
          <div class="programme-logos">
            <img src="./assets/img/logo-ayh-colour.svg" alt="Activate Your Heart Logo" width="93" />
            <img src="./assets/img/logo-space-colour.svg" alt="SPACE for COPD" width="69" />
            <img src="./assets/img/logo-ycr-colour.svg" alt="Your COVID Recovery" width="93" />
          </div>
        </div>
      </div>
    </div>